import { isCryptoUpdownDetailSlug } from '@/domain/crypto/crypto-minute-slug.js';
import { isSportFeedCategoryKey } from '@/domain/market/feed-list-category.js';
import { buildSportLiveMatchDetailRoute } from '@/domain/market/sport-detail-route.js';
import { buildMarketDetailRouteFromIds } from '@/domain/market/market-detail-symbols.js';
import { buildCryptoUpdownDetailRoute } from '@/composables/useCryptoUpdownDetailNavigation.js';
import { isSportMatchupDetailTarget } from '@/utils/sport-market-binding.js';

/**
 * 列表 / 搜索 / 收藏 / 仓位 / 相关 统一进详情。
 * 加密分钟盘 → CryptoUpdownDetail；
 * 体育对阵（主客队 / contestId / sports-slug / 四大金刚）→ SportLiveMatchDetail；
 * 其余（含无主客体育）→ MarketDetail。
 *
 * @param {{
 *   collectionId?: string,
 *   collId?: string,
 *   marketId?: string,
 *   slug?: string,
 *   category?: string,
 *   title?: string,
 *   homeTeamName?: string,
 *   awayTeamName?: string,
 *   contestId?: string,
 *   markets?: unknown[],
 *   historical?: boolean,
 *   query?: Record<string, string>,
 * }} ids
 * @returns {import('vue-router').RouteLocationRaw | null}
 */
export function resolveChannelMarketDetailRoute({
  collectionId,
  collId,
  marketId,
  slug = '',
  category = '',
  title = '',
  homeTeamName = '',
  awayTeamName = '',
  contestId = '',
  markets,
  historical = false,
  query,
} = {}) {
  const id = String(collectionId ?? collId ?? '').trim();
  const slugNorm = String(slug ?? '').trim();

  if (id && isCryptoUpdownDetailSlug(slugNorm)) {
    return buildCryptoUpdownDetailRoute({
      id,
      slug: slugNorm,
      title,
      historical,
      query,
    });
  }

  if (
    id &&
    isSportFeedCategoryKey(category) &&
    isSportMatchupDetailTarget({
      homeTeamName,
      awayTeamName,
      contestId,
      slug: slugNorm,
      collectionSlug: slugNorm,
      markets,
    })
  ) {
    return buildSportLiveMatchDetailRoute({ id, query });
  }

  return buildMarketDetailRouteFromIds({ collectionId, collId, marketId, query });
}

export function marketOpenKindForRouteName(routeName) {
  if (routeName === 'CryptoUpdownDetail') return 'updown';
  if (routeName === 'SportLiveMatchDetail') return 'sport';
  if (routeName === 'MarketDetail') return 'market';
  return '';
}
